/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IPersona from './entidades/persona';

export default class ModeloPersona {
    public consultarListaPersonasPorAgencia(IdAgencia: string) {
        return manejadorRest<IRespuesta<IPersona>>(
            () => seguridad.get(`Persona/ConsultarPersonaPorIdAgencia/${IdAgencia}`),
            true
        );
    }
    public consultarListaPersonasPorEmpresa(IdEmpresa: string) {
        return manejadorRest<IRespuesta<IPersona>>(
            () => seguridad.get(`Persona/ConsultarPersonaPorIdEmpresa/${IdEmpresa}`),
            true
        );
    }
}
